<template>
  <section>
    <header class="media mb-3">
      <div class="media-body">
        <b-form-input
          type="search"
          placeholder="Search Your Apps"
          v-model="search"
        ></b-form-input>
      </div>
      <div class="media-right">
        <b-dropdown
          right
          variant="link"
          class="d-none d-md-inline-block"
          no-caret
        >
          <template #button-content>
            <i class="fa fa-cog text-body text-decoration-none"></i>
          </template>
          <b-dropdown-item href="#" @click="startEditing()">
            Edit My Apps
          </b-dropdown-item>
          <b-dropdown-item href="/apps">
            Add More Apps
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </header>
    <i
      v-if="loading"
      class="fa fa-fw fa-circle-o-notch fa-spin text-muted"
    ></i>
    <div
      v-if="!loading && apps.length < 1"
      class="text-muted"
    >
      <i class="fa fa-fw fa-exclamation-triangle mr-1"></i>
      Your apps have not been installed yet.
      Use <a href="/auth/old">the old site</a> for now.
    </div>

    <div
      class="apps"
      v-if="!search"
    >
      <draggable
        :list="apps"
        :disabled="!dragEnabled"
        class="row"
        @change="onDragChange"
        ghost-class="ghost"
        @start="startDrag"
        @end="endDrag"
      >
        <div
          v-for="app in apps"
          :key="app.id"
          class="app col-md-3 col-lg-2 mb-3 position-relative"
        >
          <a class="position-absolute top-0 end-0 z-index-1 edit-times cursor-pointer"
             v-if="isEdit && !app.required"
             @click="removeApp(app)"
          >
            <i class="fa fa-times text-body" aria-hidden="true"></i>
          </a>
          <a
            target="_blank" :href="loginLink(app)" class="d-none d-md-block card text-body text-decoration-none"
            @click="doClick($event)"
          >
            <span class="icon d-flex flex-column justify-content-center align-items-center">
              <img :src="app.icon">
            </span>
            <span class="name small text-decoration-none d-block text-center text-muted p-2 text-nowrap text-truncate">
              {{ app.name }}
            </span>
          </a>
          <a target="_blank" :href="loginLink(app)" class="d-md-none card text-body text-decoration-none">
            <span class="media card-body">
              <span class="icon media-left mr-4 align-self-center">
                <img :src="app.icon">
              </span>
              <span class="name text-muted media-body align-self-center">
                {{ app.name }}
              </span>
            </span>
          </a>
          <!--
          <a
            v-if="isEdit"
            :href="urls.sso.edit(app)"
            class="text-body"
            title="Edit this Login"
            style="position:absolute; bottom: 45px; right:25px;"
          >
            <i class="fa fa-lock text-muted"></i>
          </a>
          -->
        </div>
      </draggable>
    </div>

    <div
      class="apps row search-results"
      v-if="search"
    >
      <div class="col-12" v-if="matches.length < 1">
        <p>Your search produced no result. <a href="#"> Click here to Add More Apps!</a></p>
      </div>

      <div
        v-for="app in matches"
        :key="app.id"
        class="app col-md-3 col-lg-2 mb-3 position-relative"
      >
        <a class="position-absolute top-0 end-0 z-index-1 edit-times cursor-pointer"
           v-if="isEdit && !app.required"
           @click="removeApp(app)"
        >
          <i class="fa fa-times text-body" aria-hidden="true"></i>
        </a>
        <a target="_blank" :href="loginLink(app)" class="d-none d-md-block card text-body text-decoration-none">
          <span class="icon d-flex flex-column justify-content-center align-items-center">
            <img :src="app.icon">
          </span>
          <span class="name small text-decoration-none d-block text-center text-muted p-2 text-nowrap text-truncate">
            {{ app.name }}
          </span>
        </a>
        <a target="_blank" :href="loginLink(app)" class="d-md-none card text-body text-decoration-none">
          <span class="media card-body">
            <span class="icon media-left mr-4 align-self-center">
              <img :src="app.icon">
            </span>
            <span class="name text-muted media-body align-self-center">
              {{ app.name }}
            </span>
          </span>
        </a>
        <!--
        <a
          v-if="isEdit"
          :href="urls.sso.edit(app)"
          class="text-body" title="Edit this Login"
          style="position:absolute; bottom: 45px; right:25px;"
        >
          <i class="fa fa-lock text-muted"></i>
        </a>
        -->
      </div>
    </div>

    <!-- settings navbar -->
    <nav class="navbar fixed-bottom navbar-dark bg-flat-dark-clouds" v-if="isEdit">
      <div class="container-fluid">
        <button
          @click="cancelEdit"
          class="btn btn-lg text-dark btn-flat-dark-clouds mr-2 text-decoration-none ml-auto btn-link"
        >
          <span>Cancel</span>
        </button>
        <button
          @click="updateApps"
          class="btn btn-lg btn-primary"
        >
          <span v-if="saving">
            <i class="fa fa-fw fa-circle-o-notch fa-spin"></i>
          </span>
          <span v-else>
            Save
          </span>
        </button>
      </div>
    </nav>
    <!-- /settings navbar -->
  </section>
</template>

<style lang="scss" scoped>
  .edit-times {
    top: 5px;
    right: 26px;
    z-index: 5;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb;
  }
</style>

<script>
// import $ from 'jquery'
import elasticlunr from 'elasticlunr'
import { debounce } from 'lodash'
import { getMyApps, updateMyApps } from '@/api'
import urls from '@/api/urls'
import alertify from 'alertify.js';
import draggable from 'vuedraggable';

const index = elasticlunr(function () {
  this.addField('name')
  this.addField('note')
  this.addField('keywords')
  this.setRef('id')
})

export default {
  props: {
    defaultSearch: {
      type: String,
      default: null,
    }
  },
  data () {
    return {
      loading: true,
      search: null,
      matches: [],
      apps: [],
      isEdit: false,
      originalList: [],
      dragEnabled: false,
      dragging: false,
      removedApps: [],
      saving: false,
      urls,
    }
  },
  components: {
    draggable,
  },
  watch: {
    search () {
      this.doSearch()
    },
  },
  async mounted () {
    try {
      let response = await getMyApps()
      this.apps = response.data;
      this.originalList = this.apps;
      this.loading = false;
      this.loadElasticDocs();
      this.search = this.defaultSearch;
    } catch (error) {
      //
    }
  },

  methods: {
    doSearch: _.debounce(function (e) {
      //this.matches = index.search(this.search);
      let searchResults = index.search(this.search, {
        expand: true
      });

      let results = [];
      if(searchResults.length) {
        results = searchResults.map(searchResult => searchResult.ref)
      }

      this.matches = this.apps.filter(app => results.indexOf(app.id.toString()) >= 0)
    }, 100),

    removeApp: function (appToRemove) {
      alertify.confirm(`Are you sure you want to remove ${appToRemove.name}?`, () => {
        this.apps = this.apps.filter(app => appToRemove.id != app.id)
        this.matches = this.matches.filter(app => appToRemove.id != app.id)
        this.removedApps.push(appToRemove)
        index.removeDoc(appToRemove)
      })
    },

    updateApps () {
      this.saving = true;
      this.updateListSortOrder()
      updateMyApps(this.apps)
      .then(result => {
        this.saving = false;
        this.isEdit = false;
        this.originalList = this.apps;
      });
    },

    cancelEdit () {
      this.isEdit = false;
      this.dragEnabled = false
      this.apps = this.originalList;
      this.loadElasticDocs()
      this.removedApps = []
    },

    loadElasticDocs () {
      this.apps.forEach(app => index.addDoc(app));
    },

    startDrag () {
      this.dragging = true;
    },

    endDrag () {
      this.dragging = false;
    },

    onDragChange () {
      this.isEdit = true;
      console.log(this.apps)
    },

    startEditing () {
      this.isEdit = true
      this.dragEnabled = true
    },

    doClick (event) {
      if (this.isEdit) event.preventDefault();
    },

    updateListSortOrder () {
      const newList = this.apps.map((item, index) => {
        const newSort = index + 1;
        item.hasChanged = item.sortOrder !== newSort; //To be removed ... just added
        if (item.hasChanged) {
          item.sortOrder = newSort;
        }
        return item;
      });
      this.apps = newList;
    },

    loginLink (app) {
      return urls.sso.login(app)
    }
  }
}
</script>
